const __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/modules/web.dom-collections.iterator.js");